export default "__VITE_ASSET__B544Z8qN__"